<template>
  <div
    class="vue-query-builder"
    :class="{ 'vue-query-builder-styled': styled }"
  >
    <query-builder-group
      :index="0"
      :query.sync="query"
      :rule-types="ruleTypes"
      :rules="mergedRules"
      :max-depth="maxDepth"
      :depth="depth"
      :styled="styled"
      :labels="mergedLabels"
      type="query-builder-group"
      :show-only="showOnly"
      :program-id="programId"
    />
  </div>
</template>

<script>
import QueryBuilderGroup from './QueryBuilderGroup.vue'
import { deepClone } from './utilities.js'

export default {

  components: {
    QueryBuilderGroup,
  },

  props: {
    rules: Array,
    labels: {
      type: Object,
      default () {
        return this.defaultLabels
      },
    },
    styled: {
      type: Boolean,
      default: true,
    },
    maxDepth: {
      type: Number,
      default: 3,
      validator: function (value) {
        return value >= 1
      },
    },
    initialQuery: Object,
    showOnly: {
      type: Boolean,
      required: true,
    },
    programId: {
      required: true,
    },

  },

  data () {
    return {
      depth: 1,
      query: {
        operator: 'and',
        value: [],
      },
      ruleTypes: {
        'text': {
          inputType: 'text',
          id: 'text-field',
        },
      },
    }
  },

  computed: {
    mergedLabels () {
      // merges the default labels with the user defined labels
      // passed  as property of the component
      return Object.assign({}, this.defaultLabels, this.labels)
    },

    mergedRules () {
      // adds the settings of predefined rules (defined in ruleTypes) to the rules
      // leaves the custom-component as is, since it is not present in the ruleType {}

      let mergedRules = []
      let vm = this

      vm.rules.forEach(function (rule) {
        if (typeof vm.ruleTypes[rule.type] !== 'undefined') {
          mergedRules.push(Object.assign({}, vm.ruleTypes[rule.type], rule))
        } else {
          mergedRules.push(rule)
        }
      })

      // a rule defines what component should be used, and with what values
      return mergedRules
    },

    defaultLabels () {
      return {
        matchTypeStart: this.trans('filters.labels.matchTypeStart'),
        matchTypeEnd: this.trans('filters.labels.matchTypeEnd'),
        matchTypeAll: this.trans('filters.labels.matchTypeAll'),
        matchTypeAny: this.trans('filters.labels.matchTypeAny'),
        addRule: this.trans('filters.labels.addRule'),
        removeRule: this.trans('filters.labels.removeRule'),
        addGroup: this.trans('filters.labels.addGroup'),
        addNot: this.trans('filters.labels.addNot'),
        notOperator: this.trans('filters.labels.notOperator'),
        removeGroup: this.trans('filters.labels.removeGroup'),
        textInputPlaceholder: this.trans('filters.labels.textInputPlaceholder'),
      }
    },
  },

  mounted () {
    this.$emit('queryUpdated', deepClone(this.query))

    this.$watch(
      'query',
      function (newQuery) {
        this.$emit('queryUpdated', deepClone(newQuery))
      }, {
        deep: true,
      })

    if (typeof this.$options.propsData.initialQuery !== 'undefined') {
      this.query = deepClone(this.$options.propsData.initialQuery)
    }
  },

}
</script>

<style>

  .btn-showAdd {
    margin: 0;
    padding: 3px;
  }
  .vue-query-builder-styled .vqb-group .rule-actions .close {
    padding-right: 15px;
    padding-top:15px;
  }

  /*.vue-query-builder-styled .panel {*/
    /*margin-bottom: 2px;*/
  /*}*/

  .vue-query-builder-styled .panel-heading select{
    height: auto;
    padding-top: 2px;
    padding-bottom: 2px;
  }

  .vue-query-builder-styled .panel-heading {
    margin-top: 8px;
  }

  .vqb-group-body {
    padding-top:0;
    padding-right:3px;
  }

  .vue-query-builder-styled .panel-heading .form-group{
    margin-top: 0 !important;
    margin-bottom: 2px;
    padding-top: 0px;
    padding-bottom: 2px;
  }

  .vue-query-builder-styled .panel-body .form-group{
    margin-top: 1px !important;
    margin-bottom: 2px;
    padding-top: 0px;
    padding-bottom: 2px;
  }

  .vue-query-builder-styled .vqb-rule {
    margin-top: 15px;
    margin-bottom: 15px;
    background-color: #f5f5f5;
    border-color: #ddd;
    padding: 15px;
  }

  .vue-query-builder-styled .vqb-rule label {
    margin-right: 10px;
  }

  .vue-query-builder-styled .vqb-group.depth-1 .vqb-rule,
  .vue-query-builder-styled .vqb-group.depth-2 {
    border-left: 2px solid #8bc34a;
  }

  .vue-query-builder-styled .vqb-group.depth-2 .vqb-rule,
  .vue-query-builder-styled .vqb-group.depth-3 {
    border-left: 2px solid #00bcd4;
  }

  .vue-query-builder-styled .vqb-group.depth-3 .vqb-rule,
  .vue-query-builder-styled .vqb-group.depth-4,
  /*All */
  .vue-query-builder-styled .vqb-group.depth-4 .vqb-group {
    border-left: 2px solid #ff5722;
  }

  .vue-query-builder-styled .close {
    opacity: 1;
    color: rgb(150,150,150);
  }

  @media (min-width: 768px) {
    .vue-query-builder-styled .vqb-rule.form-inline .form-group {
      display: block;
    }
  }
</style>
